class TiktokSwiper extends HTMLElement {
	constructor() {
		super();
		this.defaultSettings = {
			slidesPerView: 1,
			spaceBetween: 20,
			breakpoints: {
				1374: {
					slidesPerView: 4,
					spaceBetween: 28,
				},
				769: {
					slidesPerView: 3
				},
				639: {
					slidesPerView: 2
				}
			}
		};
	}

	connectedCallback() {
		const settings = this.getAttribute('data-settings');
		this.settingsJSON = settings ? JSON.parse(settings) : {};

		// console.log(settings)
		// console.log(this.settingsJSON)

		this.createSlider();
	}

	createSlider() {
		const swiperContainer = this.querySelector('.swiper-container');
		if (!swiperContainer) {
			console.error('Swiper container not found inside the custom element');
			return;
		}


		const settings = Object.assign({}, this.defaultSettings, this.settingsJSON);


		try {
			this.swiper = new Swiper(swiperContainer, settings);
			// console.log("Swiper initialized with settings:", settings);
		} catch (error) {
			console.error('Error initializing Swiper:', error);
		}
	}
}


customElements.define('tiktok-swiper', TiktokSwiper);

class VideoComponent extends HTMLElement {
	connectedCallback() {
		this.videoBtn = this.querySelector('.tiktok-feed-item__play-button');
		this.videoEl = this.querySelector('video');

		if (this.videoEl) {
			// Додаємо обробник кліків на відео
			this.videoEl.addEventListener('click', this.toggleVideo.bind(this));
		}

		if (this.videoBtn) {
			// Обробник кліків для кнопки залишається
			this.videoBtn.addEventListener('click', this.toggleVideo.bind(this));
		}

		window.addEventListener('scroll', this.handleScroll.bind(this));
	}

	static stopAllVideos(excludeComponent) {
		const allVideoComponents = document.querySelectorAll('video-component');

		allVideoComponents.forEach(component => {
			if (component !== excludeComponent) {
				const videoEl = component.querySelector('video');
				const videoBtn = component.querySelector('.tiktok-feed-item__play-button');

				if (videoEl) {
					videoEl.pause();
				}

				if (videoBtn) {
					videoBtn.setAttribute('aria-pressed', 'false');
				}
			}
		});
	}

	toggleVideo() {
		const isPressed = this.videoBtn?.getAttribute('aria-pressed') === 'true';

		if (isPressed) {
			this.videoEl.pause();
			this.videoBtn?.setAttribute('aria-pressed', 'false');
		} else {
			VideoComponent.stopAllVideos(this);
			this.videoEl.play();
			this.videoBtn?.setAttribute('aria-pressed', 'true');
		}
	}

	handleScroll() {
		const videoRect = this.getBoundingClientRect();
		const videoTop = videoRect.top;
		const videoBottom = videoRect.bottom;

		const isVideoVisible = videoTop < window.innerHeight && videoBottom > 0;

		if (!isVideoVisible) {
			this.videoEl.pause();
			this.videoBtn?.setAttribute('aria-pressed', 'false');
		}
	}
}

customElements.define('video-component', VideoComponent);
